import {useNavigate} from 'react-router-dom';
import {Restart} from '@yosmanyga/fortaleza-core';
import {BlankLayout} from '../BlankLayout.tsx';

const DeleteScreen = () => {
    const navigate = useNavigate();

    return <Restart
        templates={{
            layout: BlankLayout,
        }}
        onRestart={() => {
            navigate('/');
        }}
        onCancel={() => {
            navigate(-1);
        }}
    />
};

export {DeleteScreen};
